<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.generatorCode" clearable placeholder="单号" style="width:180px" @keyup.enter.native="search" />
      <el-select v-model="query.generatorState" clearable placeholder="状态" style="width:120px">
        <el-option label="草稿" value="00" />
        <el-option label="已生成" value="01" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>

    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="generatorCode" label="单号" width="180" />
      <el-table-column prop="generatorName" label="名称" min-width="140" show-overflow-tooltip />
      <el-table-column prop="templateTechnologyNumber" label="模板工艺" width="150" />
      <el-table-column prop="templateProductNumber" label="模板产品" width="140" />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.generatorState === '01' ? 'success' : 'info'">
            {{ row.generatorState === '01' ? '已生成' : '草稿' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createDate" label="创建时间" width="170" />
      <el-table-column label="操作" width="280" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button v-if="row.generatorState === '00'" type="text" @click="openEdit(row.generatorId)">修改</el-button>
          <el-button type="text" @click="openEdit(row.generatorId, true)">查看</el-button>
          <el-button v-if="row.generatorState === '00'" type="text" @click="generateRow(row.generatorId)">生成工艺</el-button>
          <el-button v-if="row.generatorState === '00'" type="text" style="color:#ef4444" @click="onDelete(row.generatorId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total"
      :page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage"
      @size-change="onSize"
    />

    <el-dialog :title="dialogTitle" :visible.sync="visible" width="960px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px" :disabled="readonly">
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="单号">
              <el-input v-model="form.generatorCode" placeholder="留空自动生成" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="名称">
              <el-input v-model="form.generatorName" placeholder="可选" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="模板工艺" required>
              <el-select
                v-model="form.templateTechnologyId"
                filterable
                remote
                clearable
                :remote-method="searchTech"
                :loading="techLoading"
                placeholder="输入编码/名称搜索已受理工艺"
                style="width:100%"
              >
                <el-option
                  v-for="t in techOptions"
                  :key="t.technologyId"
                  :label="(t.technologyNumber || '') + ' / ' + (t.technologyName || '') + ' [' + (t.productNumber || '') + ']'"
                  :value="t.technologyId"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input v-model="form.remark" type="textarea" :rows="2" />
            </el-form-item>
          </el-col>
        </el-row>
        <div v-if="!readonly" style="margin-bottom:8px">
          <el-button type="primary" size="mini" @click="openProductPicker">添加目标产品</el-button>
        </div>
        <el-table :data="form.productList" border size="small">
          <el-table-column prop="productNumber" label="产品编码" width="160" />
          <el-table-column prop="productName" label="产品名称" min-width="180" show-overflow-tooltip />
          <el-table-column v-if="!readonly" label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="form.productList.splice(scope.$index, 1)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="form.resultList && form.resultList.length" style="margin-top:16px">
          <div style="margin-bottom:8px;font-weight:600">生成结果</div>
          <el-table :data="form.resultList" border size="small">
            <el-table-column prop="productNumber" label="目标产品" width="160" />
            <el-table-column prop="productName" label="产品名称" min-width="140" />
            <el-table-column prop="technologyNumber" label="生成工艺编码" width="180" />
            <el-table-column prop="technologyName" label="工艺名称" min-width="160" />
          </el-table>
        </div>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">{{ readonly ? '关闭' : '取消' }}</el-button>
        <el-button v-if="!readonly" type="primary" :loading="saving" @click="submit">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="选择产品" :visible.sync="productPickerVisible" width="720px" append-to-body :close-on-click-modal="false">
      <div class="toolbar" style="margin-bottom:12px">
        <el-input v-model="productPickerQuery" clearable placeholder="产品编码/名称" style="width:220px" @keyup.enter.native="loadProductPicker" />
        <el-button type="primary" icon="el-icon-search" @click="loadProductPicker">查询</el-button>
      </div>
      <el-table
        :data="productPickerList"
        border
        v-loading="productPickerLoading"
        height="360"
        @selection-change="productPickerSelection = $event"
      >
        <el-table-column type="selection" width="48" align="center" />
        <el-table-column prop="productNumber" label="编码" width="140" />
        <el-table-column prop="productName" label="名称" min-width="180" show-overflow-tooltip />
      </el-table>
      <div slot="footer">
        <el-button @click="productPickerVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmProducts">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listTechGenerator, getTechGenerator, saveTechGenerator,
  updateTechGenerator, deleteTechGenerator, generateTechGenerator
} from '../../api/techGenerator'
import { listTechnology } from '../../api/technology'
import { listProduct } from '../../api/product'

function emptyForm() {
  return {
    generatorId: '',
    generatorCode: '',
    generatorName: '',
    templateTechnologyId: '',
    remark: '',
    productList: [],
    resultList: []
  }
}

export default {
  name: 'MesTechGeneratorPage',
  components: { ListPagination },
  data() {
    return {
      query: { generatorCode: '', generatorState: '' },
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      loading: false,
      visible: false,
      readonly: false,
      saving: false,
      form: emptyForm(),
      techOptions: [],
      techLoading: false,
      productPickerVisible: false,
      productPickerLoading: false,
      productPickerList: [],
      productPickerQuery: '',
      productPickerSelection: []
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看工艺生成器'
      return this.form.generatorId ? '修改工艺生成器' : '新增工艺生成器'
    }
  },
  created() {
    this.load()
  },
  methods: {
    indexMethod(index) {
      return (this.page - 1) * this.pageSize + index + 1
    },
    search() {
      this.page = 1
      this.load()
    },
    onPage(p) {
      this.page = p
      this.load()
    },
    onSize(s) {
      this.pageSize = s
      this.page = 1
      this.load()
    },
    load() {
      this.loading = true
      listTechGenerator({
        currentPage: this.page,
        pageSize: this.pageSize,
        generatorCode: this.query.generatorCode,
        generatorState: this.query.generatorState
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id, readonly) {
      this.readonly = !!readonly
      this.form = emptyForm()
      this.techOptions = []
      this.visible = true
      if (!id) {
        this.searchTech('')
        return
      }
      getTechGenerator(id).then(res => {
        const d = res.data || {}
        this.form = {
          generatorId: d.generatorId,
          generatorCode: d.generatorCode,
          generatorName: d.generatorName,
          templateTechnologyId: d.templateTechnologyId,
          remark: d.remark,
          productList: d.productList || [],
          resultList: d.resultList || []
        }
        if (d.templateTechnologyId) {
          this.techOptions = [{
            technologyId: d.templateTechnologyId,
            technologyNumber: d.templateTechnologyNumber,
            technologyName: d.templateTechnologyName,
            productNumber: d.templateProductNumber
          }]
        }
      })
    },
    searchTech(q) {
      this.techLoading = true
      listTechnology({
        currentPage: 1,
        pageSize: 30,
        technologyNumber: q || undefined,
        technologyState: '02',
        active: '1'
      }).then(res => {
        const body = res.data || {}
        this.techOptions = body.list || []
      }).finally(() => { this.techLoading = false })
    },
    openProductPicker() {
      this.productPickerQuery = ''
      this.productPickerSelection = []
      this.productPickerVisible = true
      this.loadProductPicker()
    },
    loadProductPicker() {
      this.productPickerLoading = true
      listProduct({
        currentPage: 1,
        pageSize: 50,
        productNumber: this.productPickerQuery,
        active: '1'
      }).then(res => {
        const body = res.data || {}
        this.productPickerList = body.list || []
      }).finally(() => { this.productPickerLoading = false })
    },
    confirmProducts() {
      const exist = new Set((this.form.productList || []).map(p => p.productId))
      ;(this.productPickerSelection || []).forEach(row => {
        if (!row.productId || exist.has(row.productId)) return
        exist.add(row.productId)
        this.form.productList.push({
          productId: row.productId,
          productNumber: row.productNumber,
          productName: row.productName
        })
      })
      this.productPickerVisible = false
    },
    submit() {
      if (!this.form.templateTechnologyId) {
        this.$message.warning('请选择模板工艺')
        return
      }
      if (!this.form.productList || !this.form.productList.length) {
        this.$message.warning('请添加目标产品')
        return
      }
      this.saving = true
      const req = this.form.generatorId ? updateTechGenerator(this.form) : saveTechGenerator(this.form)
      req.then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.load()
      }).finally(() => { this.saving = false })
    },
    generateRow(id) {
      this.$confirm('将按模板工艺为目标产品生成草稿工艺，确认继续？', '提示', { type: 'warning' }).then(() => {
        generateTechGenerator(id).then(res => {
          const n = (res.data && res.data.resultList) ? res.data.resultList.length : 0
          this.$message.success('已生成 ' + n + ' 条工艺')
          this.load()
        })
      }).catch(() => {})
    },
    onDelete(id) {
      this.$confirm('确定删除？', '提示', { type: 'warning' }).then(() => {
        deleteTechGenerator([id]).then(() => {
          this.$message.success('已删除')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>
